import { Controller } from '@hotwired/stimulus';
import axios from 'axios';

export default class extends Controller {
  static values = {
    includeBlank: { type: Boolean, default: false }, custom: { type: Boolean, default: false },
  }

  static targets = ['state', 'country']

  connect () {
    this.fetchStates();
  }

  updateStates (states) {
    const standardStateField = this.stateTarget.dataset.standardAddressStateField;
    if (standardStateField && standardStateField === 'true') {
      this.updateStandardFormStates(states);
      return;
    }

    while (this.stateTarget.firstChild) {
      this.stateTarget.removeChild(this.stateTarget.firstChild);
    }

    const closestWrapper = this.stateTarget.closest('.js-input-wrapper');
    const targetToDisplay = this.customValue ? closestWrapper : this.stateTarget;

    if (!states.length) {
      this.stateTarget.removeAttribute('required');
      targetToDisplay.hidden = true;
    } else {
      this.stateTarget.setAttribute('required', '');
      targetToDisplay.hidden = false;
    }

    if (this.includeBlankValue) {
      this.stateTarget.removeAttribute('required');
      this.stateTarget.add(new Option());
    }

    const selectedState = this.stateTarget.getAttribute('value');
    states.forEach((state) => {
      this.stateTarget.add(new Option(state, state, false, selectedState === state));
    });
  }

  updateStandardFormStates (states) {
    while (this.stateTarget.firstChild) {
      this.stateTarget.removeChild(this.stateTarget.firstChild);
    }

    const closestFormGroup = this.stateTarget.closest('.form-group.salesforce_enrollment_residential_state');

    if (!states.length) {
      this.stateTarget.removeAttribute('required');
      if (closestFormGroup) closestFormGroup.classList.add('d-none');
    } else {
      this.stateTarget.setAttribute('required', '');
      if (closestFormGroup) closestFormGroup.classList.remove('d-none');
    }

    const selectedFieldState = this.stateTarget.dataset.selectedValue;
    states.forEach((state, index) => {
      if (index === 0) {
        this.stateTarget.add(new Option('', '', true, !selectedFieldState));
      } else {
        this.stateTarget.add(new Option(state, state, false, selectedFieldState === state));
      }
    });
    if (selectedFieldState) {
      this.stateTarget.focus();
      this.stateTarget.blur();
    }
  }

  fetchStates () {
    if (!this.hasCountryTarget) return;
    const countryCode = this.countryTarget.selectedOptions[0].value;
    const { lang } = document.documentElement;
    axios.get('/api/v1/standard_app_adress/residential_states', { params: { country: countryCode, locale: lang } }).then((response) => {
      this.updateStates(response.data.states);
    })
      .catch((err) => {
        console.error(err);
      });
  }
}
